import { Link, Outlet, useLocation } from '@tanstack/react-router';
import { useMe } from '../lib/queries.js';
import { api } from '../lib/api.js';

const NAV: Array<{ to: string; label: string }> = [
  { to: '/', label: 'Dashboard' },
  { to: '/users', label: 'Usuários' },
  { to: '/workspaces', label: 'Workspaces' },
  { to: '/plans', label: 'Planos' },
  { to: '/integrations', label: 'Integrações' },
  { to: '/prompts', label: 'IA · Prompts' },
  { to: '/flags', label: 'Feature flags' },
  { to: '/payments', label: 'Pagamentos' },
  { to: '/focus-audio', label: 'Sons de Foco' },
  { to: '/audit', label: 'Audit log' },
  { to: '/2fa', label: '2FA' },
];

export function AdminShell() {
  const { data: me } = useMe();
  const loc = useLocation();

  async function logout() {
    await api('/auth/logout', { method: 'POST' });
    window.location.href = '/login';
  }

  return (
    <div className="grid grid-cols-[220px_1fr] min-h-dvh">
      <aside className="border-r border-zinc-800 bg-zinc-950 p-4 flex flex-col">
        <div className="flex items-center gap-2 mb-6">
          <div className="size-2 rounded-full bg-rose-500" />
          <div className="font-semibold">Flowmindy Admin</div>
        </div>
        <nav className="flex flex-col gap-1 text-sm">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className={`px-2 py-1.5 rounded ${
                loc.pathname === n.to
                  ? 'bg-zinc-800 text-zinc-100'
                  : 'text-zinc-400 hover:bg-zinc-900'
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="mt-auto text-xs text-zinc-500 space-y-2">
          {me && (
            <>
              <div>{me.email}</div>
              <div className="rounded bg-zinc-900 px-2 py-1 text-zinc-300 inline-block">
                {me.admin}
              </div>
            </>
          )}
          <button
            onClick={logout}
            className="block text-zinc-400 hover:text-zinc-200"
          >
            Sair
          </button>
        </div>
      </aside>
      <main className="p-8 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
